var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
export function curry(targetFn) {
    var existingArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        existingArgs[_i - 1] = arguments[_i];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var totalArgs = __spreadArray(__spreadArray([], __read(existingArgs)), __read(args));
        if (totalArgs.length >= targetFn.length) {
            return targetFn.apply(void 0, __spreadArray([], __read(totalArgs)));
        }
        return curry.apply(void 0, __spreadArray([targetFn], __read(totalArgs)));
    };
}
export function compose() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    var reduceComposedFns = function (prevFn, nextFn) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return prevFn(nextFn.apply(void 0, __spreadArray([], __read(args))));
    }; };
    return fns.reduce(reduceComposedFns);
}
export var isEmpty = function (value) {
    if (typeof value === 'object') {
        if (Array.isArray(value)) {
            return value.length ? value : undefined;
        }
        return Object.keys(value).length ? value : undefined;
    }
    return value;
};
export var reduce = curry(function (fn, initial, array) {
    return array.reduce(fn, initial);
});
export var propOr = function (key, fallback, obj) { return obj[key] || fallback; };
export var split = curry(function (pattern, string) {
    return string.split(pattern);
});
export var dig = curry(function (keys, props) {
    var splitDot = split('.');
    var reduceMappedProps = reduce(function (acc, key) { return propOr(key, {}, acc); }, props);
    return compose(isEmpty, reduceMappedProps, splitDot)(keys);
});
/* eslint-enable @typescript-eslint/no-explicit-any */
